import styled from 'styled-components';
import { responsiveProperty } from '../../utils/responsiveProperty/responsiveProperty.js';
import { getCellCSS } from './utils.js';
import { themeGet } from '../theme/themeGet/get.js';

var MAX_CELLS = 12;
var containerWidth = responsiveProperty('maxWidth', {
  base: '100%',
  lg: '87rem',
  xl: '102rem'
});
var containerPadding = responsiveProperty('padding', {
  base: "0 " + themeGet('spacing.lg'),
  sm: "0 " + themeGet('spacing.4xl')
});
var gridGap = responsiveProperty('gap', {
  base: 'lg',
  sm: '2xl'
});
var rowMargin = responsiveProperty('marginTop', {
  base: 'lg',
  sm: '2xl'
});
var GridContainer = styled.div.withConfig({
  displayName: "GridContainer",
  componentId: "sc-1tq7ye0-0"
})(["margin:0 auto;width:100%;", ";", ";"], containerWidth, containerPadding);
var GridRow = styled.div.withConfig({
  displayName: "GridRow",
  componentId: "sc-1tq7ye0-1"
})(["display:grid;grid-template-columns:repeat(", ",1fr);grid-template-rows:1fr;align-content:center;justify-items:stretch;align-items:stretch;", ";& + &{", ";}"], MAX_CELLS, gridGap, rowMargin);
var GridCell = styled.div.withConfig({
  displayName: "GridCell",
  componentId: "sc-1tq7ye0-2"
})(["", ""], function (_ref) {
  var width = _ref.width;
  return getCellCSS(width);
});

export { GridCell, GridContainer, GridRow };
